import '.az{font-family:FunnelDisplay;}.ssr-plugin'
import '.f4{font-weight:700;}.ssr-plugin'
import '.f5{margin-top:0px;}.ssr-plugin'
import '.f6{margin-bottom:1.5rem;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

export interface QuoteProps extends PropsWithChildren {
  style?: Style
}

export const Quote = ({ children, style }: QuoteProps) => {
  const isMobile = useMediaQuery()

  return (
    <styled.blockquote className="az f4 f5 f6"
      style={{
        fontSize: isMobile ? '2rem' : '3rem',
        lineHeight: isMobile ? '130%' : '100%',
        ...style,
      }}
    >
      “{children}”
    </styled.blockquote>
  )
}
